import { findBankAccounts } from "../../../repositories/qerpapi/erp/financeiro/AgenciasRepository";
import { Chip, Container, Grid, Slide, Typography } from "@material-ui/core";
import {
  BrushSharp,
  CloudUpload,
  EditOutlined,
  GetApp,
  Search,
  Visibility,
  History,
  LockOpen,
  LinkOffOutlined,
  DeleteForever,
} from "@material-ui/icons";
import { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
import Loading from "../../../components/basics/Loading";
import Btn from "../../../components/buttons/Btn";
import HeaderModule from "../../../components/header/HeaderModule";
import UploadFiles from "../../../components/uploadFiles/UploadFiles";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import { AuxSpan, OfxDiv } from "./styles/style";
import Card from "./../../../components/cards/Card";
import ModalQyonBank from "./children/ModalQyonBank";
import SelectErp from "../../../components/basics/SelectErp";
import TextFieldErp from "../../../components/basics/TextFieldErp";
import SpeedDialErp from "../../../components/speeddial/SpeedDialErp";
import useConciliacaoUploadController from "./controllers/ConciliacaoUploadController";
import {
  ConciliacaoUploadContext,
  ConciliacaoUploadContextProvider,
} from "./contexts/ConciliacaoUploadContext";
import TableDefault from "../../../components/grid/TableDefault";
import { formatDate } from "../../../utils/formatDate";
import ModalLogs from "./children/ModalLogs";
import { dateFromList, statusList } from "./constants/constants";
import { findFileLog } from "../../../repositories/qerpapi/v3/log/financeiro/conciliacao/BancariaRepository";
import { ConciliacaoBancariaContextProvider } from "./contexts/ConciliacaoBancariaContext";
import ModalOpenFinanceLogs from "./children/ModalOpenFinanceLogs";
import ModalOpenFinanceRetroactive from "./children/ModalOpenFinanceRetroactive";
import { GlobalVariables } from "../../../GlobalVariables";

const View = () => {
  const { queryParams } = useContext(QueryParamsContext);

  const {
    loading,
    setLoading,
    bankAgencies,
    setBankAgencies,
    dateFrom,
    setDateFrom,
    status,
    setStatus,
    initialDate,
    setInitialDate,
    finalDate,
    setFinalDate,
    bankAccount,
    setBankAccount,
    historicDataTable,
    pagePropDefault,
    setPagePropDefault,
    openFinanceDataTable,
  } = useContext(ConciliacaoUploadContext);

  const {
    handleOfxDownload,
    handleUpload,
    handleGetDataTable,
    handleOpenConciliation,
    handleReopenFileOfxConciliation,
    handleOpenFinanceConciliation,
    handleOpenFinanceDisconnect,
    handleOfxDelete,
    handleGetOpenFinanceDataTable,
    handleGetOpenFinanceRetroactive,
  } = useConciliacaoUploadController();

  const [file, setFile] = useState([]);
  const [item, setItem] = useState({});

  const [openedUpload, setOpenedUpload] = useState(false);
  const [modalQyonOpened, setModalQyonOpened] = useState(false);
  const [openModalLogs, setOpenModalLogs] = useState(false);

  const [openFinanceRow, setOpenFinanceRow] = useState(null);
  const [openModalOpenFinanceLogs, setOpenModalOpenFinanceLogs] =
    useState(false);

  const [openFinanceRetroactive, setOpenFinanceRetroactive] = useState(false);

  const handleCancel = () => {
    setOpenedUpload(false);
    setFile([]);
  };

  const clearDate = () => {
    setInitialDate(null);
    setFinalDate(null);
  };

  const handleCloseModalLogs = () => {
    setOpenModalLogs(false);
    setItem({});
  };

  const handleCloseModalOpenFinanceLogs = () => {
    setOpenModalOpenFinanceLogs(false);
    setOpenFinanceRow(null);
  };

  const agencyUserNotAllowed = (agencyID) => {
    // return true;
    if (!agencyID) return false;
    return !bankAgencies.some((agencie) => agencie.id === agencyID);
  };

  useEffect(() => {
    handleGetOpenFinanceDataTable();
  }, [handleGetOpenFinanceDataTable]);

  useEffect(() => {
    if (!queryParams.empresa_cnpj || !queryParams.usuario_id) return;

    async function getAgencies() {
      try {
        setLoading(true);
        const callback = await findBankAccounts({
          empresa_cnpj: queryParams.empresa_cnpj,
          usuario_id: queryParams.usuario_id,
          include: "banco",
        });

        if (!callback.success) {
          Swal.fire({
            icon: "warning",
            text: `${callback.message}`,
            showConfirmButton: true,
          }).then(async (result) => {
            return;
          });
        }

        setBankAgencies(callback.data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }

    getAgencies();
    // eslint-disable-next-line
  }, [queryParams.empresa_cnpj, queryParams.usuario_id]);

  const columnsTable = [
    {
      label: "Ações",
      format: (row) => {
        let agencyUser = agencyUserNotAllowed(row.agencia_id);
        let itemActions = [];

        if (row.status !== "CONCILIADO") {
          itemActions.push({
            icon: <EditOutlined />,
            name: "Editar",
            action: () => {
              handleOpenConciliation(row.id, row.agencia_id);
            },
            disabled: agencyUser,
          });
        } else {
          itemActions.push({
            icon: <LockOpen />,
            name: "Reabrir",
            action: () => {
              handleReopenFileOfxConciliation(row.id);
            },
            disabled: agencyUser,
          });
        }
        itemActions = itemActions.concat([
          {
            icon: <GetApp />,
            name: "Download",
            action: () => {
              handleOfxDownload(row.s3_key, row.nome);
            },
            disabled: agencyUser,
          },
          {
            icon: <History />,
            name: "Logs",
            action: () => {
              setItem(row);
              setOpenModalLogs(true);
            },
            disabled: agencyUser,
          },
        ]);

        if (row.status !== "ABERTO") {
          itemActions.push({
            icon: <Visibility />,
            name: "Visualizar",
            action: () => {
              handleOpenConciliation(row.id, row.agencia_id, true);
            },
            disabled: agencyUser,
          });
        }

        if (row.status === "ABERTO") {
          itemActions.push({
            icon: <DeleteForever />,
            name: "Remover",
            action: () => handleOfxDelete(row.id),
            disabled: agencyUser,
          });
        }

        return <SpeedDialErp actions={itemActions} />;
      },
      align: "center",
      disabled: true,
    },
    {
      label: "Arquivo",
      id: "nome",
      align: "center",
    },
    {
      label: "Conta Bancária",
      id: "apelido",
      align: "center",
      format: (row) => {
        return row?.agencia?.apelido || "-";
      },
      disabled: true,
    },
    {
      label: "Data Extrato",
      id: "data_inicio",
      align: "center",
      format: (row) => {
        let getStartDate = !!row.data_inicio;
        let getEndDate = !!row.data_fim;

        if (getStartDate && getEndDate) {
          let dataInicio = `${formatDate({
            date: row.data_inicio,
            separator: "/",
            format: "dd/mm/yyyy",
          })} ${row.data_inicio.split(" ")[1] || ""}`;

          let dataFim = `${formatDate({
            date: row.data_fim,
            separator: "/",
            format: "dd/mm/yyyy",
          })} ${row.data_fim.split(" ")[1] || ""}`;

          return `${dataInicio} - ${dataFim}`;
        } else {
          return "-";
        }
      },
    },
    {
      label: "Data Importação",
      id: "data_importacao",
      align: "center",
      format: (row) => {
        let getStandardDate = !!row.data_importacao;

        if (getStandardDate)
          return `${formatDate({
            date: row.data_importacao,
            separator: "/",
            format: "dd/mm/yyyy",
          })} ${row.data_importacao.split(" ")[1] || ""}`;
        else {
          return "-";
        }
      },
    },
    {
      label: "Data Conciliação",
      id: "data_conciliado",
      align: "center",
      format: (row) => {
        let getStandardDate = !!row.data_conciliado;

        if (getStandardDate)
          return `${formatDate({
            date: row.data_conciliado,
            separator: "/",
            format: "dd/mm/yyyy",
          })} ${row.data_conciliado.split(" ")[1] || ""}`;
        else {
          return "-";
        }
      },
    },
    {
      label: "Status",
      id: "status",
      align: "center",
      format: (row) => {
        return row.status || "-";
      },
    },
  ];

  const openFinanceColumnsTable = [
    {
      label: "Ações",
      format: (row) => {
        let agencyUser = agencyUserNotAllowed(row.agencia_id);
        let itemActions = [];

        itemActions = itemActions.concat([
          {
            icon: <EditOutlined />,
            name: "Editar",
            action: () => {
              let startDate = new Date().toISOString().split("T")[0];
              let endDate = new Date().toISOString().split("T")[0];

              handleOpenFinanceConciliation(row.id, startDate, endDate, row.id);
            },
            disabled: agencyUser,
          },
          {
            icon: <LinkOffOutlined />,
            name: "Desconectar",
            action: () => {
              handleOpenFinanceDisconnect(row.id);
            },
            disabled: agencyUser,
          },
          {
            icon: <History />,
            name: "Logs",
            action: () => {
              setOpenFinanceRow(row);
              setOpenModalOpenFinanceLogs(true);
            },
            disabled: agencyUser,
          },
        ]);

        itemActions.push({
          icon: <Search />,
          name: "Buscar movimentações retroativas",
          action: () => {
            setOpenFinanceRow(row);
            setOpenFinanceRetroactive(true);
          },
        });
        

        return <SpeedDialErp actions={itemActions} />;
      },
      align: "center",
      disabled: true,
    },
    {
      label: "Conta Bancária",
      id: "nickname",
      align: "center",
      format: (row) => {
        return row?.nickname || "-";
      },
      disabled: true,
    },
    {
      label: "Agência",
      id: "agency",
      align: "center",
      format: (row) => {
        return (
          row?.agency + (row?.agency_digit ? ` - ${row.agency_digit}` : "")
        );
      },
    },
    {
      label: "Conta",
      id: "account",
      align: "center",
      format: (row) => {
        return (
          row?.account + (row?.account_digit ? ` - ${row.account_digit}` : "")
        );
      },
    },
    {
      label: "Mov. Ignoradas",
      id: "ignred_movimentations",
      align: "center",
      format: (row) => {
        return row?.ignored || "-";
      },
      disabled: true,
    },
    {
      label: "Mov. Conciliadas",
      id: "conciliated_movimentations",
      align: "center",
      format: (row) => {
        return row?.done || "-";
      },
      disabled: true,
    },
    {
      label: "Mov. Pendentes",
      id: "pending_movimentations",
      align: "center",
      format: (row) => {
        return row?.pending || "-";
      },
      disabled: true,
    },
    {
      label: "Data de inicio",
      id: "data_inicio",
      align: "center",
      format: (row) => {
        let getStartDate = !!row.first;

        if (getStartDate) {
          let dataInicio = `${formatDate({
            date: row.first,
            separator: "/",
            format: "dd/mm/yyyy",
          })} ${row.first.split(" ")[1] || ""}`;

          return `${dataInicio}`;
        } else {
          return "-";
        }
      },
    },
    {
      label: "Última atualização",
      id: "data_importacao",
      align: "center",
      format: (row) => {
        let getStandardDate = !!row.last;

        if (getStandardDate)
          return `${formatDate({
            date: row.last,
            separator: "/",
            format: "dd/mm/yyyy",
          })} ${row.last.split(" ")[1] || ""}`;
        else {
          return "-";
        }
      },
    },
    {
      label: "Status",
      id: "status",
      align: "center",
      format: (row) => {
        return row.status;
      },
    },
  ];

  return (
    <>
      {openModalLogs && (
        <ModalLogs
          open={openModalLogs}
          handleClose={handleCloseModalLogs}
          findId={item.id || null}
          titleLog={item.nome || ""}
          handleGetLogs={(idLog) => findFileLog({ arquivo_ofx_id: idLog })}
        />
      )}

      {openModalOpenFinanceLogs && (
        <ModalOpenFinanceLogs
          open={openModalOpenFinanceLogs}
          handleClose={handleCloseModalOpenFinanceLogs}
          row={openFinanceRow}
        />
      )}

      {openFinanceRetroactive && (
        <ModalOpenFinanceRetroactive
          open={openFinanceRetroactive}
          handleClose={() => setOpenFinanceRetroactive(false)}
          handleOpenFinanceRetroactive={async (data) => {
            await handleGetOpenFinanceRetroactive(openFinanceRow.id, data.startDate, data.endDate);
            setOpenFinanceRetroactive(false);
          }}
          row={openFinanceRow}
        />
      )}

      <Loading open={loading} />
      <HeaderModule
        title="CONCILIAÇÃO BANCÁRIA"
        videoId={GlobalVariables.screenVideosIds.conciliacaoBancaria}
        receivedChild={
          <Grid item container xs spacing={2} justifyContent="flex-end">
            <Grid item style={{ display: "flex", marginTop: 5 }}>
              <Grid item>
                <OfxDiv>
                  <Btn
                    startIcon={<CloudUpload />}
                    bgcolor="primary"
                    hovercolor="orange"
                    label="Importar OFX"
                    onClick={() => {
                      setModalQyonOpened(false);
                      setOpenedUpload(!openedUpload ? true : false);
                    }}
                  />
                  <AuxSpan>*.ofx gerado pelo banco</AuxSpan>
                </OfxDiv>
              </Grid>
            </Grid>
          </Grid>
        }
      />
      <Container maxWidth="xl" style={{ marginTop: 110 }}>
        {modalQyonOpened && (
          <Slide in={modalQyonOpened} direction="down">
            <div>
              <Card>
                <Grid container style={{ marginBottom: 16 }}>
                  <Chip
                    label="QYON BANK"
                    color="primary"
                    style={{ width: "100%" }}
                  />
                </Grid>
                <ModalQyonBank
                  open={modalQyonOpened}
                  setModalOpen={setModalQyonOpened}
                  setFile={setFile}
                  setOpened={setOpenedUpload}
                  setLoading={setLoading}
                  agencies={bankAgencies}
                  handleUpload={async (customFile) =>
                    await handleUpload(null, customFile)
                  }
                />
              </Card>
            </div>
          </Slide>
        )}

        {openedUpload && (
          <Slide in={openedUpload} direction="down">
            <div>
              <Card>
                <Grid container style={{ marginBottom: 16 }}>
                  <Chip
                    label="UPLOAD DE ARQUIVO"
                    color="primary"
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid container>
                  <Grid item xs>
                    <UploadFiles
                      uploadedFiles={file}
                      setUploadedFiles={setFile}
                      accept=".ofx"
                      label="Arraste arquivos OFX aqui..."
                    />
                  </Grid>
                </Grid>

                <Grid container>
                  <AuxSpan>*.ofx gerado pelo banco</AuxSpan>
                </Grid>
                <Grid container justifyContent="flex-end" spacing={2}>
                  <Grid item>
                    <Btn
                      onClick={handleCancel}
                      label="Cancelar"
                      bgcolor="tertiary"
                      hovercolor="orange"
                    />
                  </Grid>
                  <Grid item>
                    <Btn
                      onClick={() => handleUpload(file[0])}
                      label="Realizar upload"
                      bgcolor="primary"
                      hovercolor="orange"
                    />
                  </Grid>
                </Grid>
              </Card>
            </div>
          </Slide>
        )}
      </Container>

      <Container maxWidth="xl" style={{ marginTop: 40 }}>
        <Grid container maxWidth="xl" style={{ marginBottom: 40 }}>
          <Typography variant="h5" color="primary">
            Open Finance
          </Typography>
          <Grid item xs={12}>
            <TableDefault
              smallFont
              columns={openFinanceColumnsTable}
              values={openFinanceDataTable}
              pageProp={pagePropDefault}
              setPageProp={setPagePropDefault}
              sortBy="id"
              orderSort="desc"
            />
          </Grid>
        </Grid>

        <Card fullWidth padding="20 0" line="left" lineColor="secondary">
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="flex-end"
          >
            <Grid item md={2} sm={3}>
              <SelectErp
                error={false}
                loading={false}
                label="Conta Bancária"
                value={bankAccount}
                setValue={setBankAccount}
                optionsList={bankAgencies}
                descriptionField="apelido"
              />
            </Grid>
            <Grid item md={2} sm={3}>
              <SelectErp
                error={false}
                loading={false}
                label="Status"
                value={status}
                setValue={setStatus}
                optionsList={statusList}
                descriptionField="label"
              />
            </Grid>
            <Grid item md={2} sm={3}>
              <TextFieldErp
                label="Data Inicial"
                type="date"
                size="small"
                variant="filled"
                setValue={setInitialDate}
                value={initialDate}
              />
            </Grid>

            <Grid
              item
              md={1}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Btn
                bgcolor={"whitesmoke"}
                startIcon={<BrushSharp style={{ color: "black" }} />}
                style={{ width: "40px" }}
                onClick={clearDate}
              />
            </Grid>

            <Grid item md={2} sm={3}>
              <TextFieldErp
                label="Data Final"
                type="date"
                size="small"
                variant="filled"
                setValue={setFinalDate}
                value={finalDate}
              />
            </Grid>

            <Grid item md={2} sm={3}>
              <SelectErp
                error={false}
                loading={false}
                label="Data de"
                value={dateFrom}
                setValue={setDateFrom}
                optionsList={dateFromList}
                descriptionField="label"
              />
            </Grid>

            <Grid
              item
              md={11}
              sm={3}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Btn
                startIcon={<Search />}
                bgcolor="primary"
                hovercolor="orange"
                label="Buscar"
                onClick={handleGetDataTable}
              />
            </Grid>
          </Grid>
        </Card>

        <Grid container maxWidth="xl" style={{ marginTop: 40 }}>
          <Typography variant="h5" color="primary">
            OFX
          </Typography>

          <Grid item xs={12}>
            <TableDefault
              smallFont
              columns={columnsTable}
              values={historicDataTable}
              pageProp={pagePropDefault}
              setPageProp={setPagePropDefault}
              sortBy="id"
              orderSort="desc"
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

const ConciliacaoUpload = ({ ...props }) => {
  return (
    <ConciliacaoBancariaContextProvider>
      <ConciliacaoUploadContextProvider>
        <View {...props} />
      </ConciliacaoUploadContextProvider>
    </ConciliacaoBancariaContextProvider>
  );
};

export default ConciliacaoUpload;
